<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @selectData="v=>$emit('change',v)"
    placeholder="请选择工序"
    :clearable="clearable"
    idKey="ProcessId"
    labelKey="ProcessName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require('@/api/production/teProcess').default,
    };
  },
  methods: {
    getDataFunc(params) {
      params = { ...params, ...this.params };
      // console.log("params", params);
      return new Promise((resolve, reject) => {
        this.api.list({ ...params }).then((res) => {
          resolve(res);
        });
      });
    },
  },
  select(){
    
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-input .el-input__inner{
  text-align: center;
}
</style>

